<article *ngIf="busy">
  <div>
    <h5 *ngIf="message">{{ message }}</h5>
    <img src="assets\images\cmi-icons\loading.gif" alt="Loading" height="48" />
  </div>
</article>
